import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';
import {AgrisService} from '../../../../services';
import {FiltersAgrisViewModel, FilterViewModel} from '../AgrisViewModels';

@Component({
  selector: 'app-agris-barra-busqueda',
  templateUrl: './agris-barra-busqueda.component.html',
  styleUrls: ['./agris-barra-busqueda.component.scss', '../agris-common-styles.scss']
})
export class AgrisBarraBusquedaComponent implements OnInit {

  @Output() OnSearch = new EventEmitter<string>();
  @Output() OnFilterChanged = new EventEmitter();

  searchTerm = '';
  overlayIsOpen = false;
  @Input() filterDisabled = false

  private lenghtError = false;

  filterOptionsOriginal: FiltersAgrisViewModel = {
    Rubro: [],
    SubRubro: [],
    Familia: [],
    Linea: [],
  }

  options: FiltersAgrisViewModel = {
    Rubro: [],
    SubRubro: [],
    Familia: [],
    Linea: [],
  }

  busquedaSubrubro = '';
  busquedaFamilia = '';
  busquedaLinea = '';

  filterBackup: InsumosFilter = null;

  constructor(
    private dialog: MdDialog,
    public agrisService: AgrisService,
  ) {
    agrisService.getInsumosFilter().subscribe(x => {
      if (x) {
        this.filterOptionsOriginal = x;

        // ordenamos
        this.filterOptionsOriginal.Rubro.sort((a, b) => a.Descripcion.localeCompare(b.Descripcion));
        this.filterOptionsOriginal.SubRubro.sort((a, b) => a.Descripcion.localeCompare(b.Descripcion));
        this.filterOptionsOriginal.Linea.sort((a, b) => a.Descripcion.localeCompare(b.Descripcion));
        this.filterOptionsOriginal.Familia.sort((a, b) => a.Descripcion.localeCompare(b.Descripcion));

        // añadimos las opciones para los filtros que poseen menos cantidad de valores (excluimos linea y familia)
        this.options.Rubro = this.filterOptionsOriginal.Rubro;
        this.options.SubRubro = this.filterOptionsOriginal.SubRubro;
      }
    }, err => this.agrisService.showSnackbarAPIError());
  }

  ngOnInit() {
  }

  checkEnter(e) {
    if (e.keyCode === 13) {
      event.preventDefault();
      this.onSearch();
    } else {
      this.lenghtError = false;
    }
  }

  onSearch() {
    if (this.searchTerm.trim().length > 2) {
      this.OnSearch.emit(this.searchTerm.trim().replace(' ', '-'));
    } else {
      this.lenghtError = true;
    }
  }

  onSelectFilter(type: string, value) {
    this.agrisService.filterInsumo[type] = value;
  }

  buscarItem(e, type) {
    if (type === 'subrubro') {
      this.options.SubRubro = this.filterOptionsOriginal.SubRubro.filter(x => x.Descripcion.indexOf(e.toString().toUpperCase()) !== -1);
    } else if (type === 'linea') {
      this.options.Linea = e.toString().length <= 1 ? [] : this.filterOptionsOriginal.Linea.filter(x => {
        return x.Descripcion.indexOf(e.toString().toUpperCase()) !== -1
      });
    } else if (type === 'familia') {
      this.options.Familia = e.toString().length <= 1 ? [] : this.filterOptionsOriginal.Familia.filter(x => {
        return x.Descripcion.indexOf(e.toString().toUpperCase()) !== -1
      });
    }
  }

  openOverlay() {
    this.overlayIsOpen = true;
    this.filterBackup = {...this.agrisService.filterInsumo};
  }

  onOverlayClose() {
    if (!this.compareBackupAndCurrentValue()) {
      this.OnFilterChanged.emit();
    }
  }

  compareBackupAndCurrentValue() {
    return this.filterBackup.rubro === this.agrisService.filterInsumo.rubro &&
      this.filterBackup.subRubro === this.agrisService.filterInsumo.subRubro &&
      this.filterBackup.linea === this.agrisService.filterInsumo.linea &&
      this.filterBackup.familia === this.agrisService.filterInsumo.familia
  }

}

export interface InsumosFilter {
  rubro: FilterViewModel,
  subRubro: FilterViewModel,
  familia: FilterViewModel,
  linea: FilterViewModel
}


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-barra-busqueda/agris-barra-busqueda.component.ts